module.exports = __webpack_public_path__ + "img/productPageGalleryImg01.6583d344.jpg";